// extracted by mini-css-extract-plugin
module.exports = {"frame":"style_frame__AnyhL"};